import { createSlice } from "@reduxjs/toolkit";

const storedCartList =
  localStorage.getItem("cartList") !== null
    ? JSON.parse(localStorage.getItem("cartList"))
    : [];

const initialState = {
  cartList: storedCartList,
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {


        addProduct: (state, action) => {
      const product = action.payload;
      const existing = state.cartList.find(item => item.id === product.id);
      if (existing) {
        existing.qty += 1; // increase qty if already in cart
      } else {
        state.cartList.push({ ...product, qty: 1 });
      }
    },
    addToCart: (state, action) => {
      const productToAdd = action.payload.product;
      const quantity = action.payload.num;
      const productExit = state.cartList.find(
        (item) => item.id === productToAdd.id
      );
      if (productExit) {
        state.cartList = state.cartList.map((item) =>
          item.id === action.payload.product.id
            ? { ...productExit, qty: productExit.qty + action.payload.num }
            : item
        );
      } else {
        state.cartList.push({ ...productToAdd, qty: quantity });
      }
    },
        increaseQty: (state, action) => {
      const product = state.cartList.find(item => item.id === action.payload.id);
      if (product) {
        product.qty += 1;
      }
    },
    // decreaseQty: (state, action) => {
    //   const productTodecreaseQnty = action.payload;
    //   const productExit = state.cartList.find(
    //     (item) => item.id === productTodecreaseQnty.id
    //   );
    //   if (productExit.qty === 1) {
    //     state.cartList = state.cartList.filter(
    //       (item) => item.id !== productExit.id
    //     );
    //   } else {
    //     state.cartList = state.cartList.map((item) =>
    //       item.id === productExit.id
    //         ? { ...productExit, qty: productExit.qty - 1 }
    //         : item
    //     );
    //   }
    // },
    decreaseQty: (state, action) => {
  const productTodecreaseQnty = action.payload;
  const productExit = state.cartList.find(
    (item) => item.id === productTodecreaseQnty.id
  );

  // ✅ Prevent undefined error
  if (!productExit) return;

  if (productExit.qty === 1) {
    state.cartList = state.cartList.filter(
      (item) => item.id !== productExit.id
    );
  } else {
    state.cartList = state.cartList.map((item) =>
      item.id === productExit.id
        ? { ...productExit, qty: productExit.qty - 1 }
        : item
    );
  }
},

    deleteProduct: (state, action) => {
      const productToDelete = action.payload;
      state.cartList = state.cartList.filter(
        (item) => item.id !== productToDelete.id
      );
    },
  },
});

export const cartMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  if (action.type?.startsWith("cart/")) {
    const cartList = store.getState().cart.cartList;
    localStorage.setItem("cartList", JSON.stringify(cartList));
  }
  return result;
};

export const { addToCart, decreaseQty, deleteProduct ,increaseQty,addProduct} = cartSlice.actions;

export default cartSlice.reducer;



// import { createSlice } from "@reduxjs/toolkit";

// const storedCartList =
//   localStorage.getItem("cartList") !== null
//     ? JSON.parse(localStorage.getItem("cartList"))
//     : [];

// const initialState = {
//   cartList: storedCartList,
// };

// export const cartSlice = createSlice({
//   name: "cart",
//   initialState,
//   reducers: {
//     addProduct: (state, action) => {
//       const product = action.payload;
//       const existing = state.cartList.find(item => item.id === product.id);
//       if (existing) {
//         existing.qty += 1; // increase qty if already in cart
//       } else {
//         state.cartList.push({ ...product, qty: 1 });
//       }
//     },
//     increaseQty: (state, action) => {
//       const product = state.cartList.find(item => item.id === action.payload.id);
//       if (product) {
//         product.qty += 1;
//       }
//     },
//     decreaseQty: (state, action) => {
//       const product = state.cartList.find(item => item.id === action.payload.id);
//       if (product) {
//         if (product.qty > 1) {
//           product.qty -= 1;
//         } else {
//           // remove product if qty is 1
//           state.cartList = state.cartList.filter(item => item.id !== product.id);
//         }
//       }
//     },
//     removeProduct: (state, action) => {
//       state.cartList = state.cartList.filter(item => item.id !== action.payload.id);
//     },
//   },
// });

// // Middleware to sync cart with localStorage
// export const cartMiddleware = (store) => (next) => (action) => {
//   const result = next(action);
//   if (action.type?.startsWith("cart/")) {
//     const cartList = store.getState().cart.cartList;
//     localStorage.setItem("cartList", JSON.stringify(cartList));
//   }
//   return result;
// };

// export const { addProduct, increaseQty, decreaseQty, removeProduct } = cartSlice.actions;

// export default cartSlice.reducer;
